import React from "react";
import { Container } from "react-bootstrap";
import PdfViewerCard from "../../PdfViewerCard";
import "../../incidentes.css";

const PolizaICMyL2025 = () => {
  const pdfUrl = `${process.env.REACT_APP_BUCKET}/pdf/polizas/260330-Poliza-de-Servicios.pdf`;
  /*const pdfUrl = "/pdf/260330-Poliza-de-Servicios.pdf";*/

  return (
    <>
      <Container fluid className="background-containerr">
        <div className="orgproc-header">
          <h1 className="orgproc-heading">Póliza 2025</h1>
        </div>
        <PdfViewerCard pdfUrl={pdfUrl} titulo="Póliza 2025" />
      </Container>
    </>
  );
};

 export default PolizaICMyL2025;
